export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Alcance',
                    type: 'custom-html',
                    key: 'scope',
                    modifier: (item) => {
                        return item.value;
                    }
                },
            ],
            actionObj: {
                title: '',
                type: 'action',
            }
        }
    },
}